<template>
  <div v-if="text">
    <v-dialog max-width="800" :disabled="!showDialog">
      <template #activator="{ on: dialog }">
        <v-tooltip bottom :disabled="!showDialog">
          <template #activator="{ on: tooltip }">
            <span
              :class="{ 'primary--text': showDialog }"
              :style="{ cursor: showDialog ? 'help' : 'auto' }"
              v-on="{ ...dialog, ...tooltip }"
            >
              {{ text | substringWithEllipsis(length) }}
            </span>
          </template>
          <span>{{ $t('fresh-vue.LongText.tooltip-show-more') }}</span>
        </v-tooltip>
      </template>

      <v-card>
        <v-textarea
          :value="text"
          outlined
          hide-details
          no-resize
          readonly
          class="mt-4"
          rows="12"
          row-height="25"
        />
      </v-card>
    </v-dialog>
  </div>
  <div v-else>-</div>
</template>

<script>
export default {
  name: 'LongText',

  props: {
    text: {
      type: String,
      required: false,
      default: null
    },

    length: {
      type: Number,
      required: false,
      default: 25
    }
  },

  computed: {
    showDialog() {
      return (this.text?.length || 0) > this.length
    }
  }
}
</script>
